import * as ko from "knockout";
import Bao from "./../services/bao-service";
import "./../bindings/bao-searcher";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ActivityViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.ActivityUnitId = ko.observable();
    self.ActivityUnitSearcher = {
        ObjectId: self.ActivityUnitId,
        ObjectValue: 'Name',
        SearchType: 'ActivityUnit',
        AutoComplete: true,
        AutoCompleteOpts: { preselect: false },
        AutoSearch: true,
    }

    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.Number() != null && self.Number().length > 10) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNameTooLong10Char"), "info");
            return;
        }
        if (self.Name() != null && self.Name().length > 50) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNameTooLong50Char"), "info");
            return;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.Number())
            || Bao.Utils.String.IsNullOrEmpty(self.Name())
            || Bao.Utils.String.IsNullOrEmpty(self.ActivityUnitName())
            || Bao.Utils.String.IsNullOrEmpty(self.Description())) {
            isComplete = false;
        }

        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(ActivityViewModel, SearchPaging);
ActivityViewModel.prototype.PrimaryKey = "ActivityId";
ActivityViewModel.prototype.RefreshUrl = "Activity/Get";
ActivityViewModel.prototype.SaveUrl = "Activity/Save";
ActivityViewModel.prototype.DeleteUrl = "Activity/Delete";
ActivityViewModel.prototype.IsInUseUrl = "Activity/IsInUse";
ActivityViewModel.prototype.PermissionForward = "ActivityMoveForwardSearch";
ActivityViewModel.prototype.PermissionBackward = "ActivityMoveBackwardSearch";
ActivityViewModel.prototype.PermissionSave = "ActivitySave";
ActivityViewModel.prototype.PermissionRefresh = "ActivityRefresh";
ActivityViewModel.prototype.PermissionDelete = "ActivityDelete";
export default ActivityViewModel;